export const redirectIfInIframeMixin = {
    created() {
        if (window.top !== window.self) {
            this.$router.push('/not-allowed');
        }
    },
};
